import { ReactNode } from 'react';

import { Event } from '../../Shared/types';
import { PickerItem } from '../../Shared/UI/Picker';
import { SharedProps } from '../types';
import { Footer } from '../UI/Footer';
import Layout from '../UI/Layout';
import { NavBar } from '../UI/NavBar';
import { Background } from './Background';
import Content, { Section } from './Content';

export interface Page {
  content: Section[];
}

export interface ContentPageProps extends SharedProps {
  page: Page;
  charities: (PickerItem & { logo_url: string | null; slug: string; })[];
  popularEvents: Event[];
}

export default function ContentPage({
  page,
  charities,
  popularEvents,
  contentNav,
  auth: {
    user,
  },
}: ContentPageProps) {
  return (
    <>
      <NavBar navItems={contentNav} user={user} />

      <Background />

      <div className="relative z-2">
        <Content content={page.content} charities={charities} popularEvents={popularEvents} />

        <Footer links={contentNav} />
      </div>
    </>
  );
}

ContentPage.layout = (page: ReactNode) => <Layout>{page}</Layout>;
